import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 font-inter flex flex-col justify-center h- login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center pb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto",
    width: "80",
    src: "http://192.168.1.4/storage/app/public/business/2024-01-18-65a9885147d16.png",
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold font-quicksand" }, "Área de login"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-d5 text-sm text-gray-500" }, "Acesse o sistema para registrar pedidos")
], -1)
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-md font-medium",
  for: "email"
}, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-md font-medium",
  for: "password"
}, [
  /*#__PURE__*/_createTextVNode("Senha "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["type"]
const _hoisted_9 = {
  key: 0,
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z",
  style: {"fill":"gray"}
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z",
  style: {"fill":"gray"}
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import { ref, onMounted } from 'vue'
import CentralSpinner from '../../components/loaders/CentralSpinner.vue'
import { setAuthCookies, setUser, setOrganization } from '@/utils/auth';
import { isLoading } from '@/global/state/GlobalState';
import { useToast } from "vue-toastification";
import router from '@/router';
import axiosClient from '@/api/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const toast = useToast()

const loginForm = ref<any>({
    email:'',
    password:'',
})

const showPassword = ref<boolean>(false)

onMounted(() => {
    const link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = '/favicon.png';
    document.head.append(link)
})

function login(){
    if(loginForm.value.email && loginForm.value.password){
        axiosClient.post('/sessions', loginForm.value)
        .then((res: any) => {
            const data = res.data
            setAuthCookies(data.token, data.refreshToken)
            
            if (data.user) {
                setUser(data.user)
            } else if (data.userId || data.email) {
                setUser({
                    id: data.userId || data.id,
                    sessionId: data.sessionId,
                    email: data.email,
                    name: data.name,
                })
            }

            if (data.organization) {
                setOrganization(data.organization)
            }

            toast.success('Logado com sucesso')
            router.push({name: 'organizations'})
        })
        .catch((error: any) => {
            const message = error?.response?.data?.errors?.[0]?.message || error?.response?.data.message || 'Credenciais inválidas'
            toast.error(message)
        })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        action: "",
        class: "flex flex-col gap-4 my-auto"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "p-4 py-3 border w-full rounded-xl input-primary text-sm md:text-md",
            placeholder: "ex: seuemail@gmail.com",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.value.email) = $event)),
            id: "email"
          }, null, 512), [
            [_vModelText, loginForm.value.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: showPassword.value ? 'text':'password',
              class: "p-4 border py-3 w-full rounded-xl input-primary text-sm md:text-md",
              placeholder: "ex: 878273Fy",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.value.password) = $event)),
              id: "password"
            }, null, 8, _hoisted_8), [
              [_vModelDynamic, loginForm.value.password]
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
              class: "absolute right-[5%] top-1/2 -translate-y-1/2"
            }, [
              (showPassword.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: login,
            class: "w-full p-4 py-3 text-white rounded-xl font-medium sm:mt-14 transition duration-200",
            style: _normalizeStyle({background:  loginForm.value.email && loginForm.value.password ? '#323232' : '#f5f5f5', color: loginForm.value.email && loginForm.value.password ? '#fff' : '#949494'})
          }, "Entrar", 4)
        ])
      ], 32)
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(CentralSpinner, {
          key: 0,
          zIndex: 10
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})